import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LogoutSaveService {
  private readonly saveAndExitRequested$ = new Subject<void>();
  
  // Observable that program component can subscribe to
  get saveAndExitRequested() {
    return this.saveAndExitRequested$.asObservable();
  }
  
  // Method to trigger save and exit from layout component
  triggerSaveAndExit(): void {
    this.saveAndExitRequested$.next();
  }
}